import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appAllowOnlyDigits]',
  standalone: true
})
export class AllowOnlyDigitsDirective {
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
}